const searchList = [
	{
		id: 1,
		title: "Social Media Customer Support",
		pay: "от 70 000 руб",
		experience: "3-6 лет",
		workFormat: "Офис, полный день",
		dutiesFirst: "Помогать и консультировать пользователей в социальных сетях",
		dutiesSecond: "Собирать обратную связь от пользователей по удобству, функциональности и качеству работы продуктов",
		tasks: "Анализ контента, предложение удачных решений: что заходит хорошо, что плохо, как сделать лучше. Работать в связке с копирайтером (60% контента готовит копирайтер, оставшуюся часть вам потребуется готовить оперативно в моменте). Выдвигать и тестировать гипотезы по повышению метрик показателей.",
		advantage: "Есть релевантный опыт работы Social Media Customer Support от 3 лет. Наличие опыта в сегменте Fintech/Blockchain."

	},
	{
		id: 2,
		title: "Copywriter",
		pay: "от 50 000 руб",
		experience: "1-3 года",
		workFormat: "Офис, полный день",
		dutiesFirst: "Создавать текст рекламного характера",
		dutiesSecond: "Разрабатывать слоганы и нейминг",
		tasks: "Написание креативных и информативных текстов, привлекающих внимание читателей (на русском и английском языках). SEO-оптимизация, использование ключевых слов в тексте. Работа в соответствии с заданными сроками.",
		advantage: "Опыт работы в сегменте Fintech/Blockchain."
	},
	{
		id: 3,
		title: "Influence manager - CPA",
		pay: "от 80 000 руб",
		experience: "1-3 года",
		workFormat: "Офис, полный день",
		dutiesFirst: "Разрабатывать стратегии продвижения с помощью рекламных размещений",
		dutiesSecond: "Менеджмент блогеров/стримеров",
		tasks: "Разработка стратегии продвижения с помощью рекламных размещений на ресурсах партнеров и блогеров, включая YouTube- и Telegram-каналы и тд...Менеджмент блогеров/стримеров (формирование ТЗ и брифов, контроль графика размещения контента, формирование целесообразного ценообразования), контроль выполнения договоренностей, формирование месячного бюджета на закупку контента и контроль проведения выплат/выполненных работ.Формирование и согласование плана по количеству, периодичности, тематике и стилистике публикаций.Анализ рынка, аудитории, конкурентов и эффективности рекламных кампаний.Поиск подходящих партнеров и заключение договоренностей с ними о рекламных размещениях и интеграциях.Ведение финансовой и маркетинговой отчетности по блогерам, контроль остатков контента.",
		advantage: "Опыт работы с блогерами (размещение на YouTube, Telegram, работа с партнерами) от 3-х лет. Навык копирайтинга: необходимо будет составлять ТЗ и контролировать написание продающих текстов на английском языке.Про-активность и ответственность: необходимо развить это направление с нуля.Знание английского (intermediate и выше), а также грамотный русский язык.Понимание специфики продвижения через Influence-каналы."
	}
]

export {searchList};